import React from "react";
import { FileField } from "seed/helpers";
import BaseField from "components/util/schema_form/fields/BaseField";
import l from 'components/util/l';

const FileItem = ({ file }) =>
  <a className="p-2 d-flex align-items-center btn-lighter"
    href={file.url} target="_blank" without rel="noreferrer"
    style={{ border: "1px solid #e0e0e0", width: "49%", borderRadius: "0.25rem", cursor: "pointer" }}>
    <i class="far fa-file-alt mr-2 ml-2" style={{ fontSize: "1.2em" }}></i>
    <span className="text-truncate">
      {(file?.name && file?.name != "" ? file.name : l("Archivo%SC047")).substring(33)}</span>
  </a>

const FileInput = ({
  name, label, multipleFiles, required, disabled, caption, helpMessage, value, acceptFiles,
  enableComments, values, setFieldValue
}) => {
  return (
    <BaseField
      name={name}
      label={label}
      values={values}
      required={required}
      caption={caption}
      helpMessage={helpMessage}
      enableComments={enableComments}
      setFieldValue={setFieldValue}
    >

      {value ? (
        <div className="d-flex flex-column mb-2">
          {multipleFiles ? value.map(file => <FileItem file={file} />) : null}
          {!multipleFiles ? <FileItem file={value} /> : null}
        </div>
      ) : null}

      {!disabled ? (
        <FileField
          name={name}
          accept={acceptFiles}
          className={"mt-1"}
          multiple={multipleFiles}
          setFieldValue={setFieldValue}
        />
      ) : null}

      {
        required && !value &&
        <input
          type="file"
          name={name + "_error"}
          value={value}
          required
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            zIndex: -1,
            cursor: "pointer"
          }}
        />
      }

    </BaseField>
  )
}

export default FileInput;